import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

/**
 * Formats a number with locale-specific formatting
 * @param value - The number to format
 * @returns Formatted number string with 2 decimal places
 */
export const formatNumber = (value: number): string => {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Formats a number as currency with dollar sign
 * @param value - The number to format as currency
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number): string => {
  return `$${formatNumber(value)}`;
};

/**
 * Formats a growth percentage with proper sign
 * @param growthPercentage - The percentage value to format
 * @returns Formatted percentage string with + or - sign
 */
export const formatGrowthPercentage = (growthPercentage: number): string => {
  return `${growthPercentage >= 0 ? '+' : ''}${growthPercentage.toFixed(2)}%`;
};

/**
 * Formats duration from milliseconds to hours:minutes:seconds
 * @param ms - The duration in milliseconds
 * @returns Formatted duration string (e.g., "2h:30m:45s")
 */
export const formatDuration = (ms: number): string => {
  const durationObj = dayjs.duration(ms);
  const hours = durationObj.hours();
  const minutes = durationObj.minutes();
  const seconds = durationObj.seconds();

  return `${hours}h:${minutes}m:${seconds}s`;
};
